module.exports = __webpack_public_path__ + "img/service.bf87415e.png";